module.exports = __webpack_public_path__ + "static/media/calendar_icon.bd2d8886.svg";